<template>
  <div class="d-flex align-center justify-space-between mb-4">
    <div class="text-h5 primary--text">Phụ huynh em {{ messageGroup | _get('student.name') }}</div>
    <router-link
      v-if="!isTeacher"
      class="mr-4"
      style="text-decoration: none"
      :to="'/student/' + $_get(messageGroup, 'student.id')"
    >
      Xem hồ sơ
    </router-link>
    <span class="mr-2" v-else>
      <div class="d-flex">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon size="32">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="gotoStudentDetail">
              <v-list-item-title>Xem hồ sơ học sinh</v-list-item-title>
            </v-list-item>
            <v-list-item @click="addManager">
              <v-list-item-title>Thêm BGH Nhà trường</v-list-item-title>
            </v-list-item>
            <v-list-item @click="removeManager">
              <v-list-item-title>Xóa BGH Nhà trường</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </span>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('Feedback', ['messageGroup']),
    ...mapGetters('auth', ['role']),
    ...mapGetters('constant', ['messageMemberType']),
    isTeacher() {
      return this.role.type === 'teacher'
    }
  },
  methods: {
    ...mapActions('Feedback', ['addManagerToMessageGroup', 'removeManagerToMessageGroup']),
    async addManager() {
      if (this.messageGroup.memberType === this.messageMemberType.parentTeacherManager) {
        this.$alert.error('BGH nhà trường đã được thêm vào phản hồi này')
        return
      }

      await this.addManagerToMessageGroup({
        id: this.messageGroup.id,
        memberType: this.messageMemberType.parentTeacherManager
      })
    },
    async removeManager() {
      if (this.messageGroup.memberType === this.messageMemberType.parentTeacher) {
        this.$alert.error('BGH nhà trường không có trong phản hồi này')
        return
      }

      await this.removeManagerToMessageGroup({
        id: this.messageGroup.id,
        memberType: this.messageMemberType.parentTeacher
      })
    },
    gotoStudentDetail() {
      this.$router.push(`/student/${get(this.messageGroup, 'student.id')}`)
    }
  }
}
</script>
